import * as React from "react";
import { ITaskTypeCol } from "ui/Scripts/source/models/task/taskTypeCol";
import { Translations } from "ui/Scripts/source/models/translations";
import { Box, Divider, Tooltip, Typography } from "@mui/material";
import { SectionIcon, SectionType } from "source/components/framework/Icon/SectionIcon";
import { AppReportTaskTypeRecordReference } from "ui/Scripts/source/models/appReportTemplate/appReportTaskTypeRecordReference";
import { TaskDynamicFormReferenceWarning } from "./TaskDynamicFormReferenceWarning";

interface ITaskDynamicFormRecordReferenceProp {
    taskTypeCol: ITaskTypeCol;
}

export const TaskDynamicFormRecordReference = (props: ITaskDynamicFormRecordReferenceProp) => {
    const recordReference = new AppReportTaskTypeRecordReference(props.taskTypeCol.objectValue);

    return (
        <>
            <Divider sx={{
                "maxWidth": "100%",
                "overflow": "hidden",
                "&::before, &::after": {
                    borderColor: "#000"
                }
            }}>
                <Box sx={{ padding: "8px 0" }}>
                    <Tooltip title={recordReference.name}>
                        <Box sx={{ display: "flex", alignItems: "center" }}>
                            <SectionIcon sx={{ marginRight: "8px" }} type={SectionType.UserRecords} />
                            <span>{Translations.FormRecordReference}: </span>
                            <Box component="span" marginLeft="5px">
                                {(recordReference.chartId
                                    ? recordReference.name
                                    : <Typography color="red">{"'" + Translations.NotSelected + "'"}</Typography>
                                )}
                            </Box>
                        </Box>
                    </Tooltip>
                </Box>
            </Divider>
            {!(recordReference.chartId) &&
                <TaskDynamicFormReferenceWarning
                    message={String.format(Translations.FormRecordReferenceWarning, Translations.ChartOrTableType)}
                />
            }
        </>
    );
};